import {
  type Dispatch,
  type ReactNode,
  type SetStateAction,
  createContext,
  useState,
  useContext,
} from "react";
import type { UserDetails } from "~/models/UserDetails";

type UserContextType = [
  UserDetails | null,
  Dispatch<SetStateAction<UserDetails | null>>,
];

const UserContext = createContext<UserContextType | undefined>(undefined);

function UserProvider({
  children,
  user,
}: {
  children: ReactNode;
  user: UserDetails | null;
}) {
  const [userDetails, setUserDetails] = useState<UserDetails | null>(
    user ?? null,
  );
  return (
    <UserContext.Provider value={[userDetails, setUserDetails]}>
      {children}
    </UserContext.Provider>
  );
}

function useUserDetails() {
  const context = useContext(UserContext);
  if (context === undefined) {
    throw new Error("useUserDetails must be used within a UserProvider");
  }
  return context;
}

export { UserProvider, UserContext, useUserDetails };
